import "./chunk-N3ETBM74.js";
import { POST_LOGIN_TARGET_KEY } from "@dfds-pax/utils";
const stashPostLoginTarget = (returnTo) => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(POST_LOGIN_TARGET_KEY, returnTo != null ? returnTo : window.location.href);
};
const consumePostLoginTarget = () => {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(POST_LOGIN_TARGET_KEY);
  sessionStorage.removeItem(POST_LOGIN_TARGET_KEY);
  if (!raw) return null;
  try {
    const url = new URL(raw, window.location.origin);
    return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch (e) {
    return null;
  }
};
export {
  consumePostLoginTarget,
  stashPostLoginTarget
};
